<ui-card class="profile-card" [withMargin]="false" [class.loading]="bankAccountStatus === 'loading'">
    <div class="profile-card-header">
        <h2>{{ 'company.overview.bankAccountHeader' | translate }}</h2>
        @if (bankAccountStatus === 'unverified') {
            <ui-badge type="default">{{ 'company.overview.bankAccountUnverified' | translate }}</ui-badge>
        } @else if (bankAccountStatus === 'inProgress') {
            <ui-badge type="warning">{{ 'company.overview.bankAccountInProgress' | translate }}</ui-badge>
        } @else if (bankAccountStatus === 'verified') {
            @if (!isPayrollSyncEnabled) {
                <ui-button type="link" class="margin-right-1" (click)="onOpenIframe()">{{
                    'edit' | translate
                }}</ui-button>
            }
            <ui-badge type="success">{{ 'company.overview.bankAccountVerified' | translate }}</ui-badge>
        } @else if (bankAccountStatus === 'failed') {
            <ui-badge type="danger">{{ 'company.overview.bankAccountFailed' | translate }}</ui-badge>
        }
    </div>

    <div class="profile-card-info">
        @if (bankAccountStatus === 'inProgress') {
            <ui-banner variant="info">
                {{ 'company.overview.bankAccountThankYou' | translate }}
            </ui-banner>
        }
        @if (bankAccountStatus === 'failed') {
            <ui-banner variant="danger">
                {{ 'company.overview.bankAccountError' | translate }}
            </ui-banner>
        }
        @if (bankAccountStatus === 'unverified') {
            <ui-card variant="outline">
                <h3>{{ 'company.overview.bankAccountConnect' | translate }}</h3>
                <div class="flinks-diagram margin-top-4 margin-bottom-4">
                    <img class="flinks-image" src="/assets/img/misc/flinks-connect.png" />
                </div>
                <p>{{ 'company.overview.bankAccountInfo' | translate }}</p>
                <ui-button class="margin-top-1" type="primary" (click)="onOpenIframe()">{{
                    'company.overview.bankAccountVerify' | translate
                }}</ui-button>
            </ui-card>
        }
    </div>

    <label>{{ 'company.overview.bankInstitutionLabel' | translate }}</label>
    <div>{{ bankAccount.institutionNumber || '-' }}</div>
    <label>{{ 'company.overview.bankBranchLabel' | translate }}</label>
    <div>{{ bankAccount.branchNumber || '-' }}</div>
    <label>{{ 'company.overview.bankAccountLabel' | translate }}</label>
    <div>{{ bankAccount.accountNumber || '-' }}</div>
</ui-card>

<ui-dialog
    class="flinks-dialog"
    size="large"
    header="company.overview.bankAccountVerify"
    [open]="isIframeOpen"
    (closing)="onCloseIframe()"
>
    <app-flinks-iframe
        [isOpen]="isIframeOpen"
        [companyId]="companyId"
        (accountConnectionTriggered)="onAccountConnectionTriggered()"
    />
</ui-dialog>
